import { getErrorDetail } from "components/utility/utils";
import { fetchOrchidAPI } from "utils/api";

/**
 * Query billing data by year
 */
export default async function queryBillingData(year: number) {
  const res = await fetchOrchidAPI(
    `/api/scheduler/v1/data_dashboard/billing/${year}`,
  );
  if (!res.ok) {
    throw new Error(
      `failed to get billing data by year: ${getErrorDetail(await res.text())}`,
    );
  }

  return res.json();
}
